<template>
<div class="m-module">
    <div class="section">
        <div class="page-title">
            {{ $t("lang.Fund") }}
        </div>
        <div class="body">
            <!-- <div class="filter-container">
               <van-dropdown-menu :close-on-click-outside="false">
                    <van-dropdown-item @change ="changeDro"  v-model="coinType" :options="filterOption" />
                    <van-dropdown-item v-model="queryParam.serialType" :options="tradeOption" />
                </van-dropdown-menu> 
            </div> -->
            
            <div class="list-wrapper">
                <van-list>
                    <van-swipe-cell>
                        <van-cell  v-for="item in page"  :key="item.id">
                            <div class="item">
                                <div class="item-icon">
                                    <img class="icon"  :src="api + item.btIcon" />
                                </div>
                                <div class="item-info">
                                    <div class="item-title">{{item.btFullName  }}</div>
                                    <div class="item-desc">{{ item.btShortName }}</div>
                                </div>
                                <div class="item-meta">
                                    <div class="meta">
                                        <span class="meta-label"> {{ $t("lang.alls") }}：</span>
                                        <span class="meta-val">{{ item.surplusRevoCoin }} {{ item.btUnit }}</span>
                                    </div>
                                    <div class="meta">
                                        <span class="meta-label">{{ $t("lang.available") }}：</span>
                                        <span class="meta-val">{{ item.surplusRevoCoinAdvance }} {{ item.btUnit }}</span>
                                    </div>
                                    <div class="meta">
                                        <span class="meta-label">{{ $t("lang.Frozen") }}：</span>
                                        <span class="meta-val">{{ item.freezeCoin }} {{ item.btUnit }}</span>
                                    </div>
                                    <!-- <div class="meta">
                                        <span class="meta-label">BTC价值：</span>
                                        <span class="meta-val">{{ item.rechargeProcessTime }}</span>
                                    </div> -->
                                </div>
                            </div>
                        </van-cell>
                        <template #right>
                            <van-button class="btn-opt" square type="primary" text="充值" />
                        </template>
                    </van-swipe-cell>
                    <!-- <van-swipe-cell>
                        <van-cell>
                            <div class="item">
                                <div class="item-icon">
                                    <img class="icon" :src="require('@/assets/img/coins/USDT.svg')" />
                                </div>
                                <div class="item-info">
                                    <div class="item-title">USDT</div>
                                    <div class="item-desc">USDT</div>
                                </div>
                                <div class="item-meta">
                                    <div class="meta">
                                        <span class="meta-label">全部：</span>
                                        <span class="meta-val">0.00000000</span>
                                    </div>
                                    <div class="meta">
                                        <span class="meta-label">可用：</span>
                                        <span class="meta-val">0.00000000</span>
                                    </div>
                                    <div class="meta">
                                        <span class="meta-label">已冻结：</span>
                                        <span class="meta-val">0.00000000</span>
                                    </div>
                                    <div class="meta">
                                        <span class="meta-label">BTC价值：</span>
                                        <span class="meta-val">0.00000000</span>
                                    </div>
                                </div>
                            </div>
                        </van-cell>
                        <template #right>
                            <van-button class="btn-opt" square type="primary" text="充值" />
                        </template>
                    </van-swipe-cell> -->
                </van-list>
            </div>
        </div>
        
    </div>
    <van-popup v-model="coinPopup" position="bottom" closeable :style="{ height: '50%' }">
        <div class="popup-mod">
            <div class="hd">
                <h3 class="title">Select Coin</h3>
            </div>
            <van-divider />
            <div class="bd">
                <ul class="coins">
                    <li :class="{'active':item.active}" v-for="(item, index) in coinsDataSource" :key="'coin_'+index"
                        @click="selectCoin(item, index)"
                    >
                        <div class="coin">
                            <div class="item-icon">
                                <img class="img" :src="item.icon" />
                            </div>
                            <div class="item-info">
                                <div class="item-title">{{ item.title }}</div>
                                <div class="item-desc">{{ item.desc }}</div>
                            </div>
                            <div class="item-status">
                                <i class="icon el-icon-check"></i>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="ft">
                <div class="form-action">
                    <van-button round block type="primary" @click="selectCoinSubmit">提交</van-button>
                </div>
            </div>
        </div>
    </van-popup>
    <van-popup v-model="networkPopup" position="bottom" closeable :style="{ height: '50%' }">
        <div class="popup-mod">
            <div class="hd">
                <h3 class="title">Select Network</h3>
            </div>
            <van-divider />
            <div class="bd">
                <van-notice-bar wrapable left-icon="info-o">
                    Please note that only supported networks on Rebit platform are shown. If you deposit via another network your assets may be lost.
                </van-notice-bar>
                <ul class="networks">
                    <li class="active">
                        <div class="item">
                            <div class="item-info">
                                <div class="item-title">TRX</div>
                                <div class="item-desc">Tron(TRC20)</div>
                            </div>
                            <div class="item-status">
                                <i class="icon el-icon-check"></i>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="item">
                            <div class="item-info">
                                <div class="item-title">TRX</div>
                                <div class="item-desc">Tron(TRC20)</div>
                            </div>
                            <div class="item-status">
                                <i class="icon el-icon-check"></i>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="ft">
                <div class="form-action">
                    <van-button round block type="primary">提交</van-button>
                </div>
            </div>
        </div>
    </van-popup>
    <van-popup v-model="showPicker" position="bottom">
        <van-datetime-picker
            type="datetime"
            @cancel="showPicker = false"
            @confirm="confirmDatetimePicker"
        />
    </van-popup>
</div>
</template>
<script>
import moment from "moment";
import Header from "@/components/mobile/header";
import lineChart from "@/views/account/modules/lineChart.vue";
import { Toast } from 'vant';
import {BASE_GLOB_API} from "@/config.js";
import {axiosGet,axiosPost} from '@/api/api';
export default {
    name:'fund-m',
    components: {
        Header,
        lineChart,
    },
    data(){
        return {
            coinPopup:false,
            networkPopup:false,
            showPicker:false,
            typePicker:0,
            api:BASE_GLOB_API,
            form:{
                verifyCode:''
            },
            stepActive:0,
            queryParam:{
                serialType:0,
                createTimeStart:'',
                createTimeEnd:'',
            },
            coinType:0,
            filterOption:[
                // {text:'币种', value:0}, {text:'USDT', value:1},{text:'BTC', value:2},{text:'ETC', value:3}
            ],
            tradeOption:[
                {text:'其他', value:0},
                // {text:'隐藏0资产', value:1}
            ],
            coinsDataSource:[
                {id:1, title:'USDT', desc:'USDT', icon:require('@/assets/img/coins/USDT.svg'), active:false},
                {id:2, title:'BTC', desc:'BTC', icon:require('@/assets/img/coins/BTC.svg'), active:false},
                {id:3, title:'ETC', desc:'ETC', icon:require('@/assets/img/coins/ETC.svg'), active:false},
                {id:4, title:'ETH', desc:'ETH', icon:require('@/assets/img/coins/ETH.svg'), active:false},
                {id:5, title:'TRX', desc:'TRX', icon:require('@/assets/img/coins/TRX.svg'), active:false},
            ],
            selectedCoinData:[],
            btFullList:{},
            url:{
                page:BASE_GLOB_API+'/kanban/wallet/page',
                platform:BASE_GLOB_API+'/kanban/coin/platform',
            },
            page:[],
            lang: "",
            selectedNet:{},
        }
    },
    mounted(){
        
    },
    created(){
        this.lang = sessionStorage.getItem("Language")
        this.selectedNet = JSON.parse( sessionStorage.getItem("selectedNet"));
        console.log("this.selectedNet",this.selectedNet)
        if(this.selectedNet){
            this.fetchUserPage(this.selectedNet.btPlatformId)
        }
    },
    methods:{
        changeDro(e){
          console.log("ee",e)
          this.fetchUserPage(e)
        },
        fetchUserPlatform(){
            axiosGet(this.url.platform).then(res=>{
               if(res.code ==200){
                //  this.filterOption = res.result
                //   let arrDrp =[{fullName:'eth',id:'3'},{fullName:'htl',id:'122'},{fullName:'tey',id:'222'}];
                  let arrayList =res.result,fullNameList =[]
                   arrayList.forEach(item=>{
                     let are ={
                        text:item.fullName,
                        value:item.id,
                     }
                     fullNameList.push(are)
                     this.filterOption = fullNameList
                   });
                   this.coinType = this.filterOption[0].value
                   this.fetchUserPage(this.filterOption[0].value)
               }else{
                    this.$message.error(res.message);
                }
            })
           
        }, 
        fetchUserPage(value){
            axiosPost(this.url.page,{}).then(res=>{
               if(res.code ==200){
                  this.page =res.result.records
               }else{
                    this.$message.error(res.message);
                }
            })
           
        }, 
        selectCoin(obj, index){
            this.coinsDataSource.forEach(item=>{
                item.active = false;
            });
            obj.active = true;
            this.selectedCoinData = obj;
        },
        selectCoinSubmit(){
            
        },
        showDatePicker(type){
            this.typePicker = type;
            this.showPicker = true;
        },
        confirmDatetimePicker(e){
            console.log("confirmDatetimePicker e:", e)
            let value = moment(e).format("YYYY-MM-DD HH:mm:ss");
            if(this.typePicker == 0){
                this.queryParam.createTimeStart = value;
            }else{
                this.queryParam.createTimeEnd = value;
            }
            this.$refs.item.toggle(true);
            this.showPicker = false;
        }
    }
}
</script>
<style lang="less" scoped>
.m-module {
    .section {
        .page-title {
            font-size:20px; font-weight:600; padding:30px 15px;
        }
        .body {
            .filter-container {
                .filter-form-item {
                    .van-cell__title {width:90px; min-width:90px;}
                }
            }
            .list-wrapper {
                margin-top:1px;
                .item {
                    display:flex; justify-content: space-between; align-items: flex-start;
                    .item-icon {
                        width:36px; height:36px; min-width:36px;
                        .icon {
                            width:100%; height:100%;
                        }
                    }
                    .item-info {
                        padding:0 12px 0 6px; min-width:90px;
                        .item-title {
                            font-weight:600; font-size:16px;
                        }
                        .item-desc {
                            color:#999; font-size:12px; line-height:1.37;
                        }
                    }
                    .item-meta {
                        font-size:12px; color:#666; flex:1; line-height:1.37; display:flex; justify-content: flex-start; align-items: flex-start; flex-wrap: wrap;
                        .meta {
                            width:30%; padding:0 5px 5px 0; box-sizing:border-box;
                            .meta-label {display:block;}
                            .meta-val {display:block; color:#333; font-weight:700;}
                        }
                    }
                }
            }
        }
    }
}
.steps {
    display:flex; justify-content: space-between; align-items: center;
    .step-item {
        position:relative; flex:1;
        .step-item-line {
            height:2px; background:#c0c4cc; position:absolute; left:0; right:0; top:10px;
        }
        .step-item-icon {
            width:20px; height:20px; font-size:12px; margin:0 auto; border-radius:50%; border:#c0c4cc 2px solid; display:flex; justify-content: center; align-items: center; background:#fff; color:#c0c4cc; position:relative; z-index:1;
            .el-icon-check {
                font-weight:700;
            }
        }
        .step-item-text {
            font-weight:600; padding:8px 0 10px; color:#c0c4cc; text-align: center;
        }
        &:first-child {
            .step-item-line {left:50%;}
        }
        &:last-child {
            .step-item-line {right:50%;}
        }
        &.active{
            .step-item-icon {border-color:#333; color:#333;}
            .step-item-text {color:#333;}
        }
         &.done {
            .step-item-icon {color:#fff; background:#44ac30; border-color:#44ac30;}
            .step-item-text {color:#44ac30;}
        }
    }
}
.popup-mod {
    height:100%; position:relative; overflow: hidden;
    .hd {
        padding:16px 16px;
        .title {
            font-size:16px; font-weight:700;
        }
    }
    .van-divider {margin:0;}
    .bd {
        position:absolute; top:52px; left:0; right:0; bottom:54px; overflow:auto;
        .coins {
            padding:10px;
            &>li {
                border-bottom:#e6e6e6 1px solid;
                .coin {
                    display:flex; justify-content: space-between; align-items: center; padding:10px 15px;
                    .item-icon {
                        width:32px; height:32px; min-width:32px;
                        .img {width:100%; height:100%; border-radius:50%;}
                    }
                    .item-info {
                        padding:0 10px; flex:1; text-align:left;
                        .item-title {
                            font-weight:600; color:#333;
                        }
                        .item-desc {
                            color:#999; font-size:12px;
                        }
                    }
                    .item-status {
                        display:flex; justify-content: flex-end; align-items: center;
                        .icon {display:none;}
                    }
                }
                &.active {
                    .coin {
                        background:#e8eafc; color:#4857f5; border-radius:4px;
                        .item-status {
                            .icon {color:#44ac30; display:block;}
                        }
                    }
                }
            }
        }
        .networks {
            &>li {
                padding:3px 10px;
                .item {
                     border-radius:4px; display:flex; justify-content: space-between; align-items: center; padding:10px;
                    .item-info {
                        flex:1; color:#333;
                        .item-title {
                            font-size:16px; font-weight:600;
                        }
                        .item-desc {
                            opacity: .5;
                        }
                    }
                    .item-status {
                        display:flex; justify-content: center; align-items: center;
                        .icon {display:none;}
                    }
                }
                &.active {
                    .item {
                        background:#e8eafc; color:#4857f5;
                        .item-info {
                            color:#4857f5;
                        }
                        .item-status {
                            .icon {display:block;}
                        }
                    }
                }
            }
        }
    }
    .ft {
        position:absolute; z-index:1; left:0; bottom:0; right:0; height:54px;
        .form-action {
            padding:5px 16px;
        }
    }
}
.tabbar-placeholder {
    height:54px;
}
.tabbar {
    position:fixed; left:0; bottom:0; right:0; height:54px; background:#fff; box-shadow:0 0 8px rgba(0,0,0,.08);
    .tabbar-inner {
        padding:5px 15px;
        &.u-flex {
            display:flex; justify-content: space-between; align-items: center;
            .u-flex-item {
                &:first-child {margin-right:7px;}
                &:last-child {margin-left:8px;}
            }
            .u-flex-1 {
                flex:1;
            }
            .u-flex-2 {
                flex:2;
            }
        }
    }
}
.btn-opt {height:100%;}
</style>